// Menu kategorii w widoku kolekcji (snippets/category-nav.liquid).
// Desktop: rozwijanie podkategorii. Mobile: pasek przewinięty tak, żeby bieżąca kategoria była na środku.
class CategoryNav extends HTMLElement {
  constructor() {
    super();

    this.chips = this.querySelector('.category-nav__chips');
    this.querySelectorAll('.category-nav__toggle').forEach(button => button.addEventListener('click', this.onToggleClick.bind(this)));

    if (this.chips) {
      this.scrollToActive = this.scrollToActive.bind(this);
      // na desktopie pasek jest ukryty, więc po zmianie szerokości okna liczymy pozycję od nowa
      window.matchMedia('(min-width: 992px)').addEventListener('change', this.scrollToActive);
    }
  }

  connectedCallback() {
    if (!this.chips) return;

    requestAnimationFrame(this.scrollToActive);
    // szerokość chipów zmienia się po załadowaniu fontów
    if (document.fonts) document.fonts.ready.then(this.scrollToActive);
  }

  onToggleClick(event) {
    const button = event.currentTarget;
    const expanded = button.getAttribute('aria-expanded') === 'true';

    button.setAttribute('aria-expanded', !expanded);
    document.getElementById(button.getAttribute('aria-controls')).hidden = expanded;
  }

  scrollToActive() {
    const active = this.chips.querySelector('.category-nav__chip--active');
    if (!active || !this.chips.clientWidth) return;

    const offset = active.getBoundingClientRect().left - this.chips.getBoundingClientRect().left;
    this.chips.scrollLeft += offset - (this.chips.clientWidth - active.offsetWidth) / 2;
  }
}

customElements.define('category-nav', CategoryNav);
